import type { useKindeAuth } from "@kinde-oss/kinde-auth-react";

type GetClaim = ReturnType<typeof useKindeAuth>["getClaim"];

type OrgNameClaims = { org_name?: string };

/**
 * Reads the current organization's display name from Kinde token claims.
 * Access token first, then ID token. Missing when Kinde does not include `org_name`.
 */
export async function resolveOrganizationName(
	getClaim: GetClaim,
): Promise<string | undefined> {
	const fromAccessToken = await getClaim<OrgNameClaims, string>("org_name");
	if (typeof fromAccessToken?.value === "string" && fromAccessToken.value) {
		return fromAccessToken.value;
	}

	const fromIdToken = await getClaim<OrgNameClaims, string>(
		"org_name",
		"idToken",
	);
	if (typeof fromIdToken?.value === "string" && fromIdToken.value) {
		return fromIdToken.value;
	}

	return undefined;
}
